// InstaCarSpa Chatbot Training Data - Generated from chatBot.md specification
// Each intent has extensive training phrases (EN + FR) and responses

const BOOKING_LINK = 'https://instacarspa.simplybook.me/v2/';
const PHONE = '+1 438-364-2535';
const EMAIL = 'instacarspa@gmail.com';

export const trainingData = {
  en: {
    intents: [
      // === GREETINGS ===
      {
        tag: 'greeting',
        patterns: [
          'hello', 'hi', 'hey', 'good morning', 'good afternoon', 'good evening',
          'howdy', 'what\'s up', 'sup', 'yo', 'greetings', 'bonjour',
          'hi there', 'hey there', 'hiya', 'good day', 'morning',
          'afternoon', 'evening', 'whats up', 'wassup', 'hola',
          'anyone there', 'is anyone there', 'anybody here',
          'start', 'begin', 'get started', 'lets go', 'help me',
          'i need help', 'can you help', 'help', 'assist me'
        ],
        responses: [
          'Hello! Welcome to InstaCarSpa. Are you looking for a car wash or detailing service? I can help you find the perfect package and book your appointment.'
        ],
        showBooking: false
      },

      // === LOCATIONS ===
      {
        tag: 'location',
        patterns: [
          'location', 'where', 'address', 'where are you', 'which areas',
          'montreal', 'find you', 'directions', 'near me', 'closest',
          'where is your shop', 'service area', 'do you come to me',
          'locations', 'where is', 'where do you', 'your location',
          'your address', 'how to find you', 'how to get there',
          'which location', 'what areas', 'areas you serve',
          'areas you cover', 'coverage area', 'serve my area',
          'do you serve', 'available in my area', 'nearby',
          'close to me', 'closest location', 'nearest',
          'where can i go', 'where should i go', 'which branch',
          'branches', 'outlets', 'shops', 'store', 'stores',
          'map', 'gps', 'navigate', 'find location',
          'downtown', 'west island', 'laval', 'south shore',
          'north shore', 'east end', 'west end'
        ],
        responses: [
          'Yes, we have several InstaCarSpa locations across Montreal where you can bring your vehicle. We also offer mobile service right at your parking spot! You can select your preferred location during booking.'
        ],
        showBooking: true
      },

      // === ONLINE BOOKING ===
      {
        tag: 'booking',
        patterns: [
          'book', 'appointment', 'schedule', 'reserve', 'booking', 'online booking',
          'how to book', 'make appointment', 'set up', 'sign up', 'register',
          'book now', 'reservation', 'available slots', 'availability',
          'book online', 'online appointment', 'schedule appointment',
          'make a booking', 'make reservation', 'reserve a spot',
          'reserve spot', 'get appointment', 'set appointment',
          'when can i come', 'when are you available', 'open slots',
          'free slots', 'time slots', 'available times', 'available dates',
          'next available', 'earliest available', 'soonest',
          'can i book', 'how do i book', 'where do i book',
          'i want to book', 'i want to reserve', 'i want appointment',
          'i need appointment', 'i need to book', 'schedule a wash',
          'book a wash', 'book car wash', 'book detailing',
          'book a service', 'get booked', 'secure a spot',
          'secure spot', 'lock in', 'confirm appointment'
        ],
        responses: [
          'Yes, you can book your appointment online by clicking "Book Now." It only takes a minute to choose your location, service, and time slot.'
        ],
        showBooking: true
      },

      // === WALK-IN VS APPOINTMENT ===
      {
        tag: 'walkin',
        patterns: [
          'walk in', 'walk-in', 'without appointment', 'drop in', 'just come',
          'no appointment', 'do i need to book', 'can i just show up',
          'without booking', 'come directly', 'walkin', 'drop by',
          'show up', 'come without', 'no reservation', 'no booking',
          'do i have to book', 'must i book', 'is booking required',
          'is appointment required', 'is appointment necessary',
          'can i come without booking', 'can i come anytime',
          'can i just come', 'can i just walk in', 'just drop by',
          'come in person', 'visit without', 'spontaneous',
          'on the spot', 'right now', 'come now', 'come today',
          'available now', 'open now',
          'walk in welcome', 'accept walk in', 'take walk in',
          'first come first serve', 'wait time', 'waiting',
          'how long is the wait', 'queue', 'line up'
        ],
        responses: [
          'We do accept walk-ins, but availability depends on how busy we are. To avoid waiting and guarantee your spot, we strongly recommend booking online. It only takes a minute. Most clients prefer reserving their time to avoid delays.'
        ],
        showBooking: true
      },

      // === BASIC PACKAGE ===
      {
        tag: 'basic_package',
        patterns: [
          'basic package', 'basic wash', 'basic', 'simple wash', 'quick wash',
          'cheapest option', 'starter package', 'basic cleaning', 'light wash',
          'basic plan', 'entry level', 'basic service', 'basic detail',
          'what is basic', 'tell me about basic', 'basic info',
          'basic one time', 'basic monthly', 'basic option',
          'most affordable', 'lowest price', 'budget option', 'budget wash',
          'cheap wash', 'cheap package', 'cheapest wash', 'cheapest package',
          'economy wash', 'economy package', 'standard wash', 'standard package',
          'normal wash', 'normal package',
          'simple clean', 'quick clean', 'fast wash', 'fast clean',
          'exterior and interior basic', 'basic exterior', 'basic interior',
          'just a wash', 'just wash', 'simple service', 'light cleaning',
          'light clean', 'maintenance wash', 'maintenance clean',
          'i want basic', 'give me basic', 'book basic', 'get basic'
        ],
        responses: [
          'Our Basic package includes:\n• Exterior hand wash\n• Quick interior vacuum\n• Interior surface wipe\n\nBasic is ideal for maintenance cleaning and light refresh. If your vehicle hasn\'t been cleaned in a while, Super may give you a more noticeable result.'
        ],
        showBooking: true,
        upsell: {
          message: 'Many clients add seat shampoo to remove hidden stains and odors. It makes a big difference in comfort. Would you like to include it?',
          suggestions: ['Seat shampoo', 'Salt removal', 'Spray wax']
        }
      },

      // === SUPER PACKAGE ===
      {
        tag: 'super_package',
        patterns: [
          'super package', 'super wash', 'super', 'medium package', 'mid package',
          'detailed cleaning', 'super plan', 'popular package', 'recommended package',
          'best value', 'most popular', 'super service', 'super detail',
          'what is super', 'tell me about super', 'super info',
          'super one time', 'super monthly', 'super option',
          'middle option', 'middle package', 'mid range', 'mid-range',
          'moderate package', 'moderate wash', 'moderate clean',
          'good value', 'value package', 'value wash', 'value option',
          'popular option', 'popular wash', 'popular choice',
          'recommended option', 'recommended wash',
          'your recommendation', 'best seller', 'bestseller', 'top seller',
          'door jamb', 'dashboard detailing', 'dashboard cleaning',
          'detailed interior', 'interior detail', 'more detailed',
          'deeper clean', 'deeper cleaning', 'better than basic',
          'upgrade from basic', 'step up from basic', 'next level',
          'i want super', 'give me super', 'book super', 'get super'
        ],
        responses: [
          'Our Super package includes:\n• Exterior hand wash\n• More detailed interior cleaning\n• Door jamb cleaning\n• Dashboard detailing\n\nSuper is our most popular package. It provides a more detailed interior finish and better overall refresh.'
        ],
        showBooking: true,
        upsell: {
          message: 'Would you like to add engine wash, scratch polish, or headlight restoration for an even better result?',
          suggestions: ['Engine wash', 'Scratch polish', 'Headlight restoration']
        }
      },

      // === DELUXE PACKAGE ===
      {
        tag: 'deluxe_package',
        patterns: [
          'deluxe package', 'deluxe wash', 'deluxe', 'premium package', 'full package',
          'complete package', 'best package', 'top package', 'everything', 'full service',
          'deep clean', 'deep cleaning', 'deep reset', 'full detail', 'deluxe plan',
          'deluxe service', 'deluxe detail', 'what is deluxe', 'tell me about deluxe',
          'deluxe info', 'deluxe one time', 'deluxe monthly', 'deluxe option',
          'premium wash', 'premium clean', 'premium service', 'premium option',
          'ultimate package', 'ultimate wash', 'ultimate clean',
          'top tier', 'top level', 'highest package', 'highest option',
          'most complete', 'most thorough', 'full treatment',
          'complete wash', 'complete clean', 'complete service',
          'everything included', 'all included', 'all in one', 'all-in-one',
          'engine cleaning', 'engine wash', 'engine shampoo',
          'spray wax', 'wax included', 'wax treatment',
          'near new', 'like new', 'brand new feel',
          'full restoration', 'deep restore',
          'i want deluxe', 'give me deluxe', 'book deluxe', 'get deluxe',
          'i want the best', 'give me the best', 'your best option',
          'most expensive', 'top of the line', 'vip', 'luxury wash'
        ],
        responses: [
          'Our Deluxe package includes:\n• Exterior hand wash\n• Engine cleaning\n• Interior shampoo (seats & carpets)\n• Exterior spray wax\n\nDeluxe is best if your vehicle needs a deep reset. It restores both interior and exterior to a near-new feel.'
        ],
        showBooking: true,
        upsell: {
          message: 'For long-term protection, many clients add ceramic coating or full interior protection. Would you like more details?',
          suggestions: ['Ceramic coating', 'Full interior protection']
        }
      },

      // === SERVICES / PACKAGES GENERAL ===
      {
        tag: 'services',
        patterns: [
          'services', 'what do you offer', 'what services', 'menu', 'options',
          'what can you do', 'service list', 'offerings', 'what do you do',
          'tell me about services', 'available services',
          'packages', 'all packages', 'package', 'what packages', 'show packages',
          'list packages', 'your packages', 'tell me about packages',
          'what are your packages', 'which packages', 'package options',
          'show me packages', 'show me services', 'show me options',
          'what are my options', 'what options do i have', 'what choices',
          'what do you have', 'what is available', 'whats available',
          'what you got', 'whatcha got', 'show me what you have',
          'list of services', 'list services', 'all services',
          'every service', 'every package', 'all options',
          'service menu', 'package menu', 'full menu',
          'car wash options', 'wash options', 'cleaning options',
          'detailing options', 'detail options', 'wash types',
          'types of wash', 'types of service', 'types of cleaning',
          'kinds of wash', 'kinds of service', 'different packages',
          'different services', 'different options', 'compare packages',
          'compare services', 'package comparison', 'which is which',
          'explain packages', 'explain services', 'breakdown',
          'tell me everything', 'what all do you do', 'full list',
          'car wash', 'car detailing', 'detailing', 'auto detailing',
          'car cleaning', 'auto wash', 'vehicle wash', 'vehicle cleaning'
        ],
        responses: [
          'We offer a wide range of services:\n• Car Wash (Interior/Exterior)\n• Detailing\n• Polishing & Waxing\n• Ceramic Coating\n• Wheel & Tire Deep Cleaning\n• Scratch Removal\n• Engine Cleaning\n• Headlight Restoration\n\nWe have Basic, Super, and Deluxe packages. Would you like details on any specific package?'
        ],
        showBooking: true
      },

      // === PRICING ===
      {
        tag: 'pricing',
        patterns: [
          'price', 'cost', 'how much', 'pricing', 'rates', 'fees', 'charges',
          'expensive', 'affordable', 'money', 'payment',
          'what does it cost', 'price list', 'how much does',
          'prices', 'costs', 'charge',
          'how much is', 'how much for', 'how much do you charge',
          'what do you charge', 'what is the price', 'what is the cost',
          'what are the prices', 'what are the costs', 'what are your rates',
          'price range', 'cost range', 'rate card', 'tariff',
          'how much will it cost', 'total cost', 'total price',
          'estimate', 'quote', 'quotation', 'give me a quote',
          'price estimate', 'cost estimate', 'ballpark',
          'is it expensive', 'is it cheap', 'is it affordable',
          'can i afford', 'budget friendly', 'worth it',
          'value for money', 'good deal', 'any deals',
          'discount', 'discounts', 'promo', 'promotion', 'coupon',
          'special offer', 'special price',
          'payment methods', 'how to pay', 'do you take card',
          'credit card', 'debit card', 'cash', 'e-transfer',
          'interac', 'apple pay', 'contactless'
        ],
        responses: [
          'Our prices vary based on the service and vehicle size. We have three main packages:\n• Basic - Starting from the most affordable option\n• Super - Best value, most popular\n• Deluxe - Complete deep reset\n\nMonthly packages are also available for regular maintenance. Would you like details on a specific package?'
        ],
        showBooking: true
      },

      // === WINTER / SALT ===
      {
        tag: 'winter',
        patterns: [
          'salt', 'winter', 'snow', 'white stains', 'carpet dirty', 'wet smell',
          'salt damage', 'salt removal', 'winter package', 'road salt', 'ice',
          'slush', 'calcium', 'winter cleaning', 'salt stains', 'winter wash',
          'salt buildup', 'salt build up', 'salt residue', 'salt marks',
          'winter damage', 'winter protection', 'winter care',
          'snow damage', 'snow residue', 'snow stains', 'snow marks',
          'road grime', 'road dirt', 'road residue',
          'wet carpet', 'damp carpet', 'musty smell', 'mold smell',
          'mould smell', 'smells bad', 'bad smell', 'stinky',
          'white marks', 'white residue', 'white spots',
          'calcium stains', 'calcium marks', 'calcium buildup',
          'floor mats dirty', 'floor mats stained', 'mat cleaning',
          'anti salt', 'anti-salt', 'salt treatment', 'salt protection',
          'winter special', 'seasonal', 'seasonal cleaning',
          'cold weather', 'freezing', 'frost', 'icy'
        ],
        responses: [
          'During winter in Montreal, salt buildup can permanently stain carpets and damage interiors if not treated early. We recommend adding Salt Removal or Interior Shampoo to protect your vehicle. Would you like to include that?'
        ],
        showBooking: true,
        seasonal: true
      },

      // === CERAMIC / PROTECTION ===
      {
        tag: 'ceramic',
        patterns: [
          'ceramic', 'ceramic coating', 'paint protection', 'nano coating',
          'long lasting protection', 'preserve paint', 'uv protection',
          'ceramic coat', 'nano ceramic', 'nano protection',
          'paint sealant', 'paint seal', 'clear coat', 'clear coating',
          'protective coating', 'protective layer', 'shield',
          'uv damage', 'oxidation', 'oxidation protection',
          'chemical protection', 'weather protection',
          'long term protection', 'long term shine', 'lasting shine',
          'lasting protection', 'permanent protection', 'permanent shine',
          'hydrophobic', 'water repellent', 'water beading',
          'easy maintenance', 'easier to clean', 'self cleaning',
          'keep it shiny', 'stay shiny', 'maintain shine',
          'protect my car', 'protect my paint', 'protect paint',
          'preserve my car', 'keep it new',
          'windshield ceramic', 'window ceramic', 'glass coating',
          'mirror coating', 'windshield coating', 'window coating'
        ],
        responses: [
          'If you\'re looking for long-term protection and enhanced shine, ceramic coating provides extended durability and easier maintenance. It protects against UV damage, oxidation, and chemicals. Would you like more details or to book a ceramic coating session?'
        ],
        showBooking: true
      },

      // === MONTHLY PACKAGES ===
      {
        tag: 'monthly',
        patterns: [
          'monthly', 'subscription', 'monthly package', 'monthly plan',
          'regular wash', 'weekly', 'recurring', 'every month', 'membership',
          'monthly deal', 'sign up monthly', 'monthly service',
          'monthly subscription', 'monthly membership', 'monthly option',
          'month to month', 'per month', 'each month', 'every week',
          'weekly wash', 'weekly service', 'weekly cleaning',
          'regular cleaning', 'regular service', 'regular maintenance',
          'ongoing service', 'ongoing wash', 'continuous',
          'keep it clean', 'keep clean', 'stay clean', 'always clean',
          'all month', 'all month long', 'whole month',
          'subscribe', 'enroll', 'join', 'sign me up',
          'recurring wash', 'recurring service', 'repeat service',
          'how often', 'frequency', 'how many washes',
          '4 washes', 'four washes', 'washes per month',
          'monthly exterior', 'monthly basic', 'monthly super',
          'best deal', 'save money', 'savings', 'cheaper long term'
        ],
        responses: [
          'Our monthly packages keep your car sparkling all month long:\n• Exterior Monthly - 4 exterior washes/month\n• Basic Monthly - 4 basic interior/exterior washes/month\n• Super Monthly - 4 basic washes + 1 interior detailing + 1 wheel deep wash + 1 body spray wax/month\n\nMonthly packages offer the best value for regular maintenance.'
        ],
        showBooking: true
      },

      // === VEHICLE CONDITION / RECOMMENDATION ===
      {
        tag: 'recommendation',
        patterns: [
          'which package', 'recommend', 'what should i get', 'best for me',
          'suggestion', 'not sure which', 'help me choose', 'which one',
          'what do you recommend', 'advise', 'confused', 'which is best',
          'recommendation', 'suggest', 'suggestions', 'advice',
          'which should i choose', 'which should i pick', 'which to choose',
          'which to pick', 'help me decide', 'help me pick',
          'cant decide', 'can\'t decide', 'undecided', 'unsure',
          'what is best for', 'what is right for', 'what suits',
          'what fits', 'what works for', 'best option for me',
          'right package for me', 'right option for me',
          'my car is dirty', 'my car is very dirty', 'my car is filthy',
          'my car needs cleaning', 'my car needs a wash',
          'haven\'t washed in', 'havent washed', 'long time no wash',
          'first time', 'never been here', 'new customer', 'new here',
          'moderately dirty', 'heavily dirty', 'very dirty',
          'slightly dirty', 'a little dirty', 'kind of dirty',
          'really dirty', 'super dirty', 'extremely dirty',
          'deep refresh', 'need a refresh', 'needs refresh'
        ],
        responses: [
          'I\'d love to help you choose! Could you tell me — is your vehicle moderately dirty, heavily dirty, or are you looking for a deep refresh?\n\n• Moderate → Super is usually the best value for most clients\n• Heavy → Deluxe would be ideal with interior shampoo and engine cleaning\n• Light maintenance → Basic keeps things fresh between deeper cleans'
        ],
        showBooking: false
      },

      // === DURATION / TIME ===
      {
        tag: 'duration',
        patterns: [
          'how long', 'duration', 'how many hours', 'how long does it take',
          'waiting time', 'turnaround', 'how long will it take', 'how much time',
          'time needed', 'time required', 'how many minutes',
          'how fast', 'how quick', 'is it quick', 'is it fast',
          'will it take long', 'takes long', 'takes how long',
          'turnaround time', 'completion time', 'finish time',
          'when will it be done', 'when will it be ready',
          'how long to wait', 'wait how long', 'waiting period',
          'same day', 'same day service', 'how long for basic',
          'how long for super', 'how long for deluxe',
          'rush service', 'express wash',
          'in a hurry', 'hurry', 'urgent', 'asap'
        ],
        responses: [
          'Service duration depends on the package and vehicle size. Basic is the quickest, while Deluxe takes more time for the thorough deep clean. You can select your preferred time slot when booking online.'
        ],
        showBooking: true
      },

      // === CONTACT / PHONE / EMAIL ===
      {
        tag: 'contact',
        patterns: [
          'contact', 'phone', 'call', 'email', 'whatsapp', 'reach you',
          'phone number', 'talk to someone', 'speak to someone', 'human',
          'customer service', 'support', 'get in touch',
          'contact info', 'contact information', 'contact details',
          'your number', 'your phone', 'your email', 'your whatsapp',
          'how to contact', 'how to reach', 'how to call',
          'give me your number', 'give me your email',
          'can i call', 'can i email', 'can i text', 'can i message',
          'text you', 'message you', 'dm you', 'write to you',
          'send email', 'send message', 'reach out',
          'talk to a person', 'speak to a person', 'real person',
          'live person', 'live agent', 'live chat', 'human agent',
          'operator', 'representative', 'rep', 'agent',
          'i want to talk', 'i want to speak', 'i want to call',
          'connect me', 'transfer me', 'put me through'
        ],
        responses: [
          `You can reach us anytime:\n📞 ${PHONE}\n📲 WhatsApp available\n📧 ${EMAIL}\n\nOr book directly online for the fastest service.`
        ],
        showBooking: false
      },

      // === SPECIAL INQUIRIES (ESCALATION) ===
      {
        tag: 'special',
        patterns: [
          'fleet', 'dealership', 'corporate', 'partnership', 'bulk',
          'heavy stains', 'accident', 'custom quote', 'complaint',
          'refund', 'not satisfied', 'unhappy',
          'frustrated', 'angry', 'terrible', 'bad service', 'manager',
          'fleet pricing', 'fleet discount', 'fleet service',
          'corporate account', 'corporate pricing', 'corporate deal',
          'business account', 'business pricing', 'company account',
          'dealership partnership', 'dealer', 'car dealer',
          'bulk pricing', 'bulk discount', 'volume discount',
          'multiple cars', 'many cars', 'several cars', 'whole fleet',
          'custom service', 'custom package', 'custom work',
          'special request', 'special service', 'special need',
          'heavy duty', 'heavy cleaning', 'extreme cleaning',
          'accident damage', 'collision damage', 'body damage',
          'paint damage', 'deep scratches', 'major scratches',
          'file complaint', 'make complaint', 'i want to complain',
          'i want refund', 'money back', 'get refund',
          'not happy', 'disappointed', 'dissatisfied', 'poor service',
          'bad experience', 'worst', 'horrible', 'awful',
          'speak to manager', 'talk to manager', 'supervisor',
          'escalate', 'unacceptable', 'ridiculous'
        ],
        responses: [
          `For special requests or custom quotes, please contact us directly and our team will respond shortly.\n📞 ${PHONE}\n📲 WhatsApp available\n📧 ${EMAIL}`
        ],
        showBooking: false,
        escalation: true
      },

      // === POLISHING / WAXING / SCRATCH ===
      {
        tag: 'polishing',
        patterns: [
          'polish', 'polishing', 'wax', 'waxing', 'scratch', 'scratches',
          'scratch removal', 'remove scratches', 'fix scratches',
          'swirl marks', 'swirls', 'paint scuffs', 'scuffs',
          'buffing', 'buff', 'wet sanding', 'sand',
          'paint correction', 'paint repair', 'paint fix',
          'minor scratches', 'small scratches', 'light scratches',
          'surface scratches', 'surface damage',
          'dull paint', 'faded paint', 'oxidized paint', 'oxidized',
          'restore shine', 'bring back shine', 'make it shine',
          'glossy', 'gloss', 'mirror finish', 'showroom finish',
          'decontamination', 'iron deposits', 'brake dust removal',
          'tar removal', 'insect residue', 'bug removal',
          'exterior polishing', 'body polish', 'car polish'
        ],
        responses: [
          'We offer professional polishing, waxing, and scratch removal services:\n• Exterior Polishing & Scratch Removal - Smooths surfaces, removes minor scratches & swirls\n• Exterior Decontamination & Waxing - Removes iron deposits, brake dust, tar, followed by wax protection\n\nThese services restore your vehicle\'s shine and protect the paint.'
        ],
        showBooking: true
      },

      // === WHEEL / TIRE CLEANING ===
      {
        tag: 'wheels',
        patterns: [
          'wheel', 'wheels', 'tire', 'tires', 'rim', 'rims',
          'wheel cleaning', 'tire cleaning', 'rim cleaning',
          'wheel wash', 'tire wash', 'rim wash',
          'brake dust', 'wheel grime', 'dirty wheels', 'dirty rims',
          'dirty tires', 'wheel deep clean', 'tire deep clean',
          'alloy wheels', 'alloy cleaning', 'spoke cleaning',
          'wheel shine', 'tire shine', 'tire dressing',
          'curb rash', 'wheel damage', 'wheel restoration'
        ],
        responses: [
          'We offer Wheel & Tire Deep Cleaning that removes all brake dust and grime, keeping your rims and tires polished and shiny. This service is included in our Super Monthly package, or available as an individual service.'
        ],
        showBooking: true
      },

      // === HEADLIGHT RESTORATION ===
      {
        tag: 'headlight',
        patterns: [
          'headlight', 'headlights', 'headlight restoration',
          'foggy headlights', 'cloudy headlights', 'yellow headlights',
          'dim headlights', 'hazy headlights', 'oxidized headlights',
          'headlight cleaning', 'headlight repair', 'headlight fix',
          'restore headlights', 'clean headlights', 'fix headlights',
          'headlamp', 'headlamps', 'front lights', 'light restoration'
        ],
        responses: [
          'We offer professional headlight restoration — deep cleaning and restoring foggy, cloudy, or yellowed headlights to improve visibility and appearance. This can also be added as an upgrade to our Super package.'
        ],
        showBooking: true
      },

      // === UPHOLSTERY / LEATHER / SEATS ===
      {
        tag: 'upholstery',
        patterns: [
          'upholstery', 'leather', 'seats', 'seat cleaning', 'seat shampoo',
          'leather treatment', 'leather conditioning', 'leather care',
          'leather cleaning', 'leather seats', 'fabric seats',
          'cloth seats', 'seat stains', 'seat stain', 'stained seats',
          'dirty seats', 'clean seats', 'wash seats',
          'shampoo seats', 'shampooing', 'carpet shampoo',
          'carpet cleaning', 'floor cleaning', 'floor mats',
          'interior shampoo', 'deep interior', 'interior stains',
          'spill', 'spills', 'food stains', 'drink stains',
          'coffee stain', 'juice stain', 'pet hair', 'dog hair',
          'cat hair', 'animal hair', 'odor', 'odors', 'smell',
          'remove odor', 'remove smell', 'deodorize', 'freshen up'
        ],
        responses: [
          'We offer Upholstery Shampooing and Leather Treatment:\n• Seat shampooing for fabric and cloth seats\n• Cleaning, treating, and conditioning leather surfaces\n• Carpet and floor mat deep cleaning\n\nNote: Interior wash or detailing must be added with this service.'
        ],
        showBooking: true
      },

      // === THANKS ===
      {
        tag: 'thanks',
        patterns: [
          'thank', 'thanks', 'thank you', 'appreciate it', 'very helpful',
          'thanks a lot', 'thank you so much', 'much appreciated',
          'thx', 'ty', 'tysm', 'thanks so much', 'many thanks',
          'that helps', 'that helped', 'so helpful',
          'you rock', 'you are great', 'youre great', 'good job',
          'well done', 'that was helpful', 'i appreciate it',
          'cheers', 'much obliged'
        ],
        responses: [
          'You\'re welcome! Is there anything else I can help you with? If you\'re ready, you can book your appointment anytime.'
        ],
        showBooking: false
      },

      // === GOODBYE ===
      {
        tag: 'goodbye',
        patterns: [
          'bye', 'goodbye', 'see you', 'take care', 'done',
          'that\'s all', 'nothing else', 'no thanks',
          'good bye', 'see ya', 'see you later', 'catch you later',
          'gotta go', 'got to go', 'have to go', 'leaving',
          'im done', 'i am done', 'all done', 'thats it',
          'that is all', 'nothing more', 'no more questions',
          'no more', 'im good', 'i am good', 'all good',
          'have a good day', 'have a nice day', 'good night',
          'nite', 'cya', 'ttyl', 'talk later', 'peace',
          'no thank you', 'nah', 'nope', 'no its fine',
          'no thats fine', 'im all set', 'all set'
        ],
        responses: [
          'Thank you for chatting with InstaCarSpa! We look forward to making your car shine. Have a great day!'
        ],
        showBooking: false
      },

      // === HESITATION / FRICTION REDUCTION ===
      {
        tag: 'hesitation',
        patterns: [
          'maybe later', 'i\'ll think about it', 'not sure', 'let me think',
          'i don\'t know', 'hmm', 'idk', 'not now', 'later',
          'maybe', 'perhaps', 'possibly', 'we\'ll see', 'well see',
          'ill think', 'let me consider', 'need to think',
          'not ready', 'not yet', 'not right now', 'some other time',
          'another time', 'another day', 'next time', 'next week',
          'thinking about it', 'considering', 'on the fence',
          'still deciding', 'still thinking', 'give me time',
          'need more time', 'come back later', 'check back',
          'ill come back', 'ill be back', 'ill let you know',
          'i will let you know', 'get back to you'
        ],
        responses: [
          'No pressure at all! Booking takes less than 60 seconds and you can always reschedule if needed. Whenever you\'re ready, we\'re here.'
        ],
        showBooking: false
      },

      // === MOBILE / IN-BUILDING SERVICE ===
      {
        tag: 'mobile',
        patterns: [
          'mobile', 'come to me', 'at my place', 'home service', 'parking',
          'my building', 'in-building', 'at home', 'door service', 'on-site',
          'mobile service', 'come to my place', 'come to my home',
          'come to my building', 'come to my parking', 'at my parking',
          'in my building', 'in my parking', 'at my door',
          'doorstep', 'at doorstep', 'home delivery', 'delivery service',
          'do you come', 'will you come', 'can you come',
          'come to us', 'visit us', 'visit me', 'on site',
          'onsite', 'on-site service', 'mobile detailing',
          'mobile wash', 'mobile cleaning', 'portable',
          'convenience', 'convenient', 'at my convenience',
          'dont want to drive', 'don\'t want to drive',
          'pick up', 'pickup', 'drop off', 'dropoff',
          'condo', 'apartment', 'building parking', 'underground parking',
          'garage', 'my garage', 'driveway', 'my driveway',
          'transportation fee', 'transport fee', 'travel fee',
          'extra charge for mobile', 'mobile fee', 'delivery fee'
        ],
        responses: [
          'Yes! We offer in-building car wash and detailing service right at your parking spot. It\'s the most convenient way to keep your car clean. Select your location when booking and we\'ll come to you.\n\nNote: For mobile service, transportation fees will be added to the prices.'
        ],
        showBooking: true
      },

      // === HOURS / OPEN / SCHEDULE ===
      {
        tag: 'hours',
        patterns: [
          'hours', 'opening hours', 'closing hours',
          'business hours', 'working hours', 'operating hours',
          'what time', 'when open', 'when close', 'when do you open',
          'when do you close', 'are you open', 'are you closed',
          'open today', 'open tomorrow', 'open weekend', 'open sunday',
          'open saturday', 'open monday', 'weekend hours',
          'weekday hours', 'holiday hours',
          'what days', 'which days', 'days of operation',
          'open on holidays', 'closed on holidays',
          'early morning', 'late evening', 'night service',
          'after hours', 'before hours', 'overtime'
        ],
        responses: [
          'You can check our available time slots and hours by clicking Book Now — the booking system shows all available dates and times for your preferred location.'
        ],
        showBooking: true
      },

      // === VEHICLE SIZE / TYPE ===
      {
        tag: 'vehicle_size',
        patterns: [
          'car size', 'vehicle size', 'suv', 'sedan', 'compact',
          'minivan', 'pickup', 'truck', 'van', 'hatchback',
          'coupe', 'convertible', 'sports car', 'luxury car',
          'big car', 'small car', 'large vehicle', 'small vehicle',
          '2 seat', '5 seat', '7 seat', 'two seat', 'five seat', 'seven seat',
          'what size', 'which size', 'size of car', 'type of car',
          'does size matter', 'price by size', 'cost by size',
          'suv price', 'sedan price', 'compact price',
          'minivan price', 'pickup price', 'truck price',
          'do you wash suv', 'do you wash trucks', 'do you do suv',
          'large suv', 'full size', 'mid size', 'midsize',
          'crossover', 'jeep', 'tesla', 'electric car', 'ev'
        ],
        responses: [
          'We service all vehicle sizes! Our pricing is based on three categories:\n• 2 Seat Compact Cars\n• 5 Seat Sedans & SUVs\n• 7 Seat SUVs, Pickups & Minivans\n\nYou can select your vehicle size when booking.'
        ],
        showBooking: true
      },

      // === ECO-FRIENDLY ===
      {
        tag: 'eco',
        patterns: [
          'eco', 'eco-friendly', 'ecofriendly', 'green', 'environment',
          'environmental', 'biodegradable', 'sustainable', 'organic',
          'chemical free', 'chemical-free', 'non toxic', 'non-toxic',
          'safe products', 'safe chemicals', 'what products',
          'which products', 'products you use', 'cleaning products',
          'water usage', 'water waste', 'save water', 'waterless'
        ],
        responses: [
          'InstaCarSpa is an eco-friendly service! We use modern biodegradable and eco-friendly products for all our cleaning. Our goal is to provide the best car wash experience while being environmentally responsible.'
        ],
        showBooking: true
      },

      // === ABOUT / IDENTITY ===
      {
        tag: 'about',
        patterns: [
          'what is instacarspa', 'what is insta car spa', 'what is insta carspa',
          'who is instacarspa', 'who are you', 'about instacarspa',
          'about insta car spa', 'tell me about instacarspa',
          'tell me about insta car spa',
          'about you', 'about your company', 'about your business',
          'what is this', 'what is this place', 'what is this company',
          'who are you guys', 'what are you', 'describe instacarspa',
          'describe your business', 'what kind of business',
          'what type of business', 'what company is this',
          'instacarspa', 'insta car spa', 'isntacarspa',
          'what is isntacarspa', 'about isntacarspa'
        ],
        responses: [
          'InstaCarSpa is a professional car wash and detailing service based in Montreal. We offer eco-friendly interior and exterior cleaning, polishing, ceramic coating, and more. We have multiple locations and also provide mobile service right at your parking spot. Would you like to know about our packages or book an appointment?'
        ],
        showBooking: true
      }
    ],

    // Default fallback
    fallback: `Thanks for your message! I'm not sure I understood that correctly. You can ask me about our services, packages, pricing, or locations. For detailed inquiries, please contact us:\n📞 ${PHONE}\n📧 ${EMAIL}`,
    fallbackShowBooking: true,

    // Abandonment recovery
    abandonment: 'Would you like help choosing the right package? I can recommend one based on your vehicle\'s condition.',

    // Booking CTA
    bookNowText: '👉 Book Now',
    bookingLink: BOOKING_LINK
  },

  fr: {
    intents: [
      // === SALUTATIONS ===
      {
        tag: 'greeting',
        patterns: [
          'bonjour', 'salut', 'allo', 'bonsoir', 'bon matin', 'hey',
          'coucou', 'bonne journée', 'hello', 'hi',
          'bon après-midi', 'bonne soirée', 'allô',
          'quelqu\'un est là', 'y a quelqu\'un', 'aide',
          'aidez-moi', 'j\'ai besoin d\'aide', 'pouvez-vous m\'aider',
          'commencer', 'début', 'démarrer', 'on commence'
        ],
        responses: [
          'Bonjour! Bienvenue chez InstaCarSpa. Cherchez-vous un service de lavage ou d\'esthétique automobile? Je peux vous aider à trouver le forfait idéal et réserver votre rendez-vous.'
        ],
        showBooking: false
      },

      // === EMPLACEMENTS ===
      {
        tag: 'location',
        patterns: [
          'emplacement', 'où', 'adresse', 'où êtes-vous', 'localisation',
          'montréal', 'trouver', 'directions', 'proche', 'succursale',
          'où est votre magasin', 'zone de service',
          'emplacements', 'vos emplacements', 'votre adresse',
          'comment vous trouver', 'comment s\'y rendre',
          'quel emplacement', 'quelles zones', 'zones desservies',
          'zones couvertes', 'zone de couverture', 'desservez ma zone',
          'disponible dans ma zone', 'à proximité', 'près de moi',
          'le plus proche', 'succursale la plus proche',
          'où puis-je aller', 'quelle succursale', 'succursales',
          'points de service', 'magasin', 'magasins', 'boutique',
          'carte', 'gps', 'naviguer', 'trouver emplacement',
          'centre-ville', 'ouest de l\'île', 'rive sud', 'rive nord',
          'est', 'ouest', 'laval'
        ],
        responses: [
          'Oui, nous avons plusieurs succursales InstaCarSpa à Montréal où vous pouvez apporter votre véhicule. Nous offrons aussi un service mobile directement à votre place de stationnement! Vous pourrez choisir l\'emplacement lors de la réservation.'
        ],
        showBooking: true
      },

      // === RÉSERVATION EN LIGNE ===
      {
        tag: 'booking',
        patterns: [
          'réserver', 'rendez-vous', 'réservation', 'planifier', 'en ligne',
          'comment réserver', 'prendre rendez-vous', 'inscription', 'disponibilité',
          'réserver maintenant', 'créneaux disponibles',
          'réserver en ligne', 'rendez-vous en ligne', 'planifier rendez-vous',
          'faire une réservation', 'prendre un rendez-vous', 'réserver une place',
          'obtenir rendez-vous', 'fixer rendez-vous',
          'quand puis-je venir', 'quand êtes-vous disponible',
          'places disponibles', 'heures disponibles', 'dates disponibles',
          'prochain disponible', 'premier disponible', 'le plus tôt',
          'puis-je réserver', 'comment je réserve', 'où je réserve',
          'je veux réserver', 'je veux un rendez-vous',
          'j\'ai besoin d\'un rendez-vous', 'je dois réserver',
          'réserver un lavage', 'réserver esthétique',
          'réserver un service', 'confirmer rendez-vous', 'sécuriser place'
        ],
        responses: [
          'Oui, vous pouvez réserver en ligne en cliquant sur « Réserver maintenant ». Choisissez l\'emplacement, le service et l\'heure qui vous convient. Cela prend moins d\'une minute.'
        ],
        showBooking: true
      },

      // === SANS RENDEZ-VOUS ===
      {
        tag: 'walkin',
        patterns: [
          'sans rendez-vous', 'walk-in', 'venir directement', 'pas de rendez-vous',
          'juste passer', 'est-ce que je dois réserver', 'arriver sans réserver',
          'walk in', 'passer directement', 'sans réservation',
          'dois-je réserver', 'faut-il réserver', 'réservation obligatoire',
          'rendez-vous obligatoire', 'rendez-vous nécessaire',
          'puis-je venir sans réserver', 'puis-je venir n\'importe quand',
          'venir en personne', 'spontané', 'sur place',
          'maintenant', 'venir maintenant', 'venir aujourd\'hui',
          'disponible maintenant', 'ouvert maintenant', 'êtes-vous ouvert',
          'acceptez sans rendez-vous', 'premier arrivé', 'temps d\'attente',
          'attente', 'combien de temps attendre', 'file d\'attente'
        ],
        responses: [
          'Nous acceptons les visites sans rendez-vous, mais la disponibilité dépend de l\'achalandage. Pour éviter l\'attente et garantir votre place, nous recommandons fortement de réserver en ligne. Cela prend moins d\'une minute. La majorité de nos clients préfèrent sécuriser leur plage horaire.'
        ],
        showBooking: true
      },

      // === FORFAIT BASIQUE ===
      {
        tag: 'basic_package',
        patterns: [
          'forfait basique', 'basique', 'lavage simple', 'lavage rapide',
          'option la moins chère', 'forfait de base', 'nettoyage léger',
          'plan basique', 'entrée de gamme', 'basic',
          'service basique', 'détail basique', 'c\'est quoi basique',
          'parlez-moi du basique', 'info basique',
          'basique une fois', 'basique mensuel', 'option basique',
          'le plus abordable', 'prix le plus bas', 'option budget',
          'lavage pas cher', 'forfait pas cher', 'le moins cher',
          'lavage économique', 'forfait économique', 'forfait standard',
          'lavage régulier', 'forfait régulier', 'lavage normal',
          'nettoyage simple', 'nettoyage rapide', 'lavage vite',
          'juste un lavage', 'service simple', 'entretien léger',
          'je veux basique', 'donnez-moi basique', 'réserver basique'
        ],
        responses: [
          'Notre forfait Basique comprend :\n• Lavage extérieur à la main\n• Aspirateur intérieur rapide\n• Essuyage des surfaces principales\n\nBasique est idéal pour un entretien régulier et un rafraîchissement léger. Si votre véhicule n\'a pas été nettoyé depuis un moment, Super pourrait donner un résultat plus visible.'
        ],
        showBooking: true,
        upsell: {
          message: 'Plusieurs clients ajoutent le shampoing des sièges pour éliminer les taches et odeurs invisibles. La différence est notable. Souhaitez-vous l\'ajouter?',
          suggestions: ['Shampoing sièges', 'Traitement anti-sel', 'Cire en spray']
        }
      },

      // === FORFAIT SUPER ===
      {
        tag: 'super_package',
        patterns: [
          'forfait super', 'super', 'forfait moyen', 'nettoyage détaillé',
          'plan super', 'forfait populaire', 'forfait recommandé',
          'meilleur rapport qualité', 'le plus populaire',
          'service super', 'détail super', 'c\'est quoi super',
          'parlez-moi du super', 'info super',
          'super une fois', 'super mensuel', 'option super',
          'option milieu', 'forfait milieu', 'milieu de gamme',
          'forfait modéré', 'lavage modéré', 'nettoyage modéré',
          'bon rapport qualité', 'forfait valeur', 'meilleure valeur',
          'option populaire', 'choix populaire',
          'votre recommandation', 'meilleur vendeur', 'plus vendu',
          'cadrage de portes', 'tableau de bord', 'nettoyage tableau de bord',
          'intérieur détaillé', 'plus détaillé', 'plus approfondi',
          'mieux que basique', 'niveau supérieur',
          'je veux super', 'donnez-moi super', 'réserver super'
        ],
        responses: [
          'Notre forfait Super comprend :\n• Lavage extérieur à la main\n• Nettoyage intérieur plus approfondi\n• Nettoyage des cadrages de portes\n• Détail du tableau de bord\n\nSuper est notre forfait le plus populaire. Il offre une finition intérieure plus détaillée et un meilleur rafraîchissement global.'
        ],
        showBooking: true,
        upsell: {
          message: 'Souhaitez-vous ajouter un lavage moteur, un polissage anti-rayures ou une restauration des phares pour un résultat encore meilleur?',
          suggestions: ['Lavage moteur', 'Polissage anti-rayures', 'Restauration phares']
        }
      },

      // === FORFAIT DELUXE ===
      {
        tag: 'deluxe_package',
        patterns: [
          'forfait deluxe', 'deluxe', 'forfait premium', 'forfait complet',
          'meilleur forfait', 'tout inclus', 'service complet',
          'nettoyage en profondeur', 'remise à neuf', 'plan deluxe',
          'service deluxe', 'détail deluxe', 'c\'est quoi deluxe',
          'parlez-moi du deluxe', 'info deluxe',
          'deluxe une fois', 'deluxe mensuel', 'option deluxe',
          'lavage premium', 'nettoyage premium', 'service premium',
          'forfait ultime', 'lavage ultime', 'nettoyage ultime',
          'haut de gamme', 'plus haut niveau', 'forfait le plus complet',
          'le plus complet', 'traitement complet',
          'lavage complet', 'nettoyage complet', 'service complet',
          'tout inclus', 'tout compris',
          'nettoyage moteur', 'lavage moteur', 'shampoing moteur',
          'shampoing intérieur',
          'cire en spray', 'cire incluse', 'traitement cire',
          'comme neuf', 'état neuf', 'restaurer', 'restauration',
          'je veux deluxe', 'donnez-moi deluxe', 'réserver deluxe',
          'je veux le meilleur', 'votre meilleure option',
          'le plus cher', 'vip', 'lavage luxe'
        ],
        responses: [
          'Notre forfait Deluxe comprend :\n• Lavage extérieur à la main\n• Nettoyage moteur\n• Shampoing intérieur (sièges et tapis)\n• Cire extérieure vaporisée\n\nDeluxe est idéal si votre véhicule a besoin d\'une remise à neuf complète. Il restaure l\'intérieur et l\'extérieur à un état quasi neuf.'
        ],
        showBooking: true,
        upsell: {
          message: 'Pour une protection à long terme, plusieurs clients ajoutent le revêtement céramique ou la protection intérieure complète. Souhaitez-vous plus de détails?',
          suggestions: ['Revêtement céramique', 'Protection intérieure complète']
        }
      },

      // === SERVICES / FORFAITS GÉNÉRAL ===
      {
        tag: 'services',
        patterns: [
          'services', 'qu\'offrez-vous', 'quels services', 'menu', 'options',
          'que faites-vous', 'liste des services', 'offres', 'disponible',
          'forfaits', 'tous les forfaits', 'forfait', 'quels forfaits',
          'montrer les forfaits', 'vos forfaits', 'liste des forfaits',
          'montrez-moi les forfaits', 'montrez-moi les services',
          'montrez-moi les options', 'quelles sont mes options',
          'quels choix', 'qu\'avez-vous', 'qu\'est-ce qui est disponible',
          'montrez-moi ce que vous avez', 'tous les services',
          'chaque service', 'chaque forfait', 'toutes les options',
          'menu des services', 'menu des forfaits',
          'options de lavage', 'options de nettoyage',
          'options d\'esthétique', 'types de lavage',
          'types de service', 'types de nettoyage',
          'différents forfaits', 'différents services',
          'comparer les forfaits', 'comparaison des forfaits',
          'expliquer les forfaits', 'expliquer les services',
          'dites-moi tout', 'liste complète',
          'lavage auto', 'esthétique auto', 'esthétique',
          'nettoyage auto', 'lavage véhicule', 'nettoyage véhicule'
        ],
        responses: [
          'Nous offrons une large gamme de services :\n• Lavage auto (Intérieur/Extérieur)\n• Esthétique\n• Polissage & Cirage\n• Revêtement Céramique\n• Nettoyage profond Roues & Pneus\n• Élimination des Rayures\n• Nettoyage Moteur\n• Restauration des Phares\n\nNous avons des forfaits Basique, Super et Deluxe. Souhaitez-vous des détails sur un forfait spécifique?'
        ],
        showBooking: true
      },

      // === TARIFS ===
      {
        tag: 'pricing',
        patterns: [
          'prix', 'coût', 'combien', 'tarifs', 'frais', 'charges',
          'cher', 'abordable', 'pas cher', 'argent', 'payer', 'paiement',
          'combien ça coûte', 'liste de prix',
          'combien est', 'combien pour', 'combien chargez-vous',
          'que chargez-vous', 'quel est le prix', 'quel est le coût',
          'quels sont les prix', 'quels sont les coûts', 'quels sont vos tarifs',
          'fourchette de prix', 'gamme de prix', 'grille tarifaire',
          'combien ça va coûter', 'coût total', 'prix total',
          'estimation', 'devis', 'soumission', 'donnez-moi un devis',
          'estimation de prix', 'estimation de coût',
          'est-ce cher', 'est-ce abordable', 'est-ce que je peux me le permettre',
          'rapport qualité-prix', 'bonne affaire', 'des offres',
          'rabais', 'réduction', 'promo', 'promotion', 'coupon',
          'offre spéciale', 'prix spécial', 'solde', 'en solde',
          'méthodes de paiement', 'comment payer', 'acceptez-vous les cartes',
          'carte de crédit', 'carte de débit', 'comptant', 'virement',
          'interac', 'apple pay', 'sans contact', 'tap'
        ],
        responses: [
          'Nos prix varient selon le service et la taille du véhicule. Nous avons trois forfaits principaux :\n• Basique - L\'option la plus abordable\n• Super - Meilleur rapport qualité-prix, le plus populaire\n• Deluxe - Remise à neuf complète\n\nDes forfaits mensuels sont aussi disponibles pour l\'entretien régulier. Souhaitez-vous des détails sur un forfait spécifique?'
        ],
        showBooking: true
      },

      // === HIVER / SEL ===
      {
        tag: 'winter',
        patterns: [
          'sel', 'hiver', 'neige', 'taches blanches', 'tapis sale', 'odeur humide',
          'dommages sel', 'traitement sel', 'forfait hiver', 'sel de route', 'glace',
          'gadoue', 'calcium', 'nettoyage hiver', 'taches de sel',
          'accumulation de sel', 'résidu de sel', 'marques de sel',
          'dommages hiver', 'protection hiver', 'soin hiver',
          'dommages neige', 'résidu neige', 'taches neige',
          'saleté route', 'crasse route', 'résidu route',
          'tapis mouillé', 'tapis humide', 'odeur moisi', 'odeur moisissure',
          'sent mauvais', 'mauvaise odeur', 'puant',
          'marques blanches', 'résidu blanc', 'taches blanches',
          'taches calcium', 'marques calcium', 'accumulation calcium',
          'tapis de sol sale', 'tapis taché', 'nettoyage tapis',
          'anti sel', 'anti-sel', 'traitement anti-sel', 'protection sel',
          'spécial hiver', 'saisonnier', 'nettoyage saisonnier',
          'temps froid', 'gel', 'givre', 'glacé'
        ],
        responses: [
          'Pendant l\'hiver à Montréal, l\'accumulation de sel peut tacher les tapis et endommager l\'intérieur si ce n\'est pas traité rapidement. Nous recommandons d\'ajouter un traitement anti-sel ou un shampoing intérieur pour protéger votre véhicule. Souhaitez-vous l\'ajouter?'
        ],
        showBooking: true,
        seasonal: true
      },

      // === CÉRAMIQUE / PROTECTION ===
      {
        tag: 'ceramic',
        patterns: [
          'céramique', 'revêtement céramique', 'protection peinture', 'nano',
          'longue durée', 'préserver peinture', 'protection uv', 'durabilité',
          'revêtement', 'nano céramique', 'nano protection',
          'scellant peinture', 'couche protectrice', 'bouclier',
          'dommages uv', 'oxydation', 'protection oxydation',
          'protection chimique', 'protection intempéries',
          'protection long terme', 'brillance long terme',
          'brillance durable', 'protection durable', 'protection permanente',
          'hydrophobe', 'anti-eau', 'repousse eau',
          'entretien facile', 'plus facile à nettoyer',
          'garder brillant', 'rester brillant', 'maintenir brillance',
          'protéger ma voiture', 'protéger ma peinture',
          'préserver peinture', 'garder comme neuf',
          'céramique pare-brise', 'céramique vitres', 'revêtement verre',
          'revêtement rétroviseurs', 'revêtement pare-brise'
        ],
        responses: [
          'Si vous cherchez une protection à long terme et une brillance améliorée, le revêtement céramique offre une durabilité prolongée et un entretien plus facile. Il protège contre les dommages UV, l\'oxydation et les produits chimiques. Souhaitez-vous plus de détails ou réserver une séance de revêtement céramique?'
        ],
        showBooking: true
      },

      // === FORFAITS MENSUELS ===
      {
        tag: 'monthly',
        patterns: [
          'mensuel', 'abonnement', 'forfait mensuel', 'plan mensuel',
          'lavage régulier', 'hebdomadaire', 'récurrent', 'chaque mois',
          'adhésion', 'offre mensuelle', 'service mensuel',
          'abonnement mensuel', 'adhésion mensuelle', 'option mensuelle',
          'mois à mois', 'par mois', 'chaque semaine',
          'lavage hebdomadaire', 'service hebdomadaire',
          'nettoyage régulier', 'service régulier', 'entretien régulier',
          'service continu', 'garder propre', 'rester propre', 'toujours propre',
          'tout le mois', 'mois complet',
          's\'abonner', 's\'inscrire', 'rejoindre', 'inscrivez-moi',
          'lavage récurrent', 'service récurrent',
          'combien de fois', 'fréquence', 'combien de lavages',
          '4 lavages', 'quatre lavages', 'lavages par mois',
          'mensuel extérieur', 'mensuel basique', 'mensuel super',
          'meilleure offre', 'économiser', 'économies', 'moins cher long terme'
        ],
        responses: [
          'Nos forfaits mensuels gardent votre voiture étincelante tout le mois :\n• Extérieur Mensuel - 4 lavages extérieurs/mois\n• Basique Mensuel - 4 lavages basiques intérieur/extérieur/mois\n• Super Mensuel - 4 lavages basiques + 1 esthétique intérieure + 1 lavage profond roues + 1 cire en spray/mois\n\nLes forfaits mensuels offrent le meilleur rapport qualité-prix pour l\'entretien régulier.'
        ],
        showBooking: true
      },

      // === RECOMMANDATION ===
      {
        tag: 'recommendation',
        patterns: [
          'quel forfait', 'recommander', 'que devrais-je prendre', 'meilleur pour moi',
          'suggestion', 'pas sûr lequel', 'aidez-moi à choisir', 'lequel',
          'que recommandez-vous', 'conseiller', 'confus', 'quel est le meilleur',
          'recommandation', 'suggérer', 'suggestions', 'conseil',
          'lequel choisir', 'lequel prendre', 'aidez-moi à décider',
          'je ne peux pas décider', 'indécis', 'pas certain',
          'quel est le meilleur pour', 'quel convient', 'quel correspond',
          'ma voiture est sale', 'ma voiture est très sale',
          'ma voiture a besoin de nettoyage', 'ma voiture a besoin d\'un lavage',
          'pas lavé depuis', 'longtemps sans lavage',
          'première fois', 'jamais venu', 'nouveau client', 'nouveau ici',
          'modérément sale', 'très sale', 'légèrement sale',
          'un peu sale', 'vraiment sale', 'extrêmement sale',
          'rafraîchissement', 'besoin d\'un rafraîchissement'
        ],
        responses: [
          'Je serais ravi de vous aider à choisir! Votre véhicule est-il légèrement sale, très sale, ou souhaitez-vous un nettoyage en profondeur?\n\n• Modéré → Super est généralement le meilleur rapport qualité-prix\n• Très sale → Deluxe serait idéal avec shampoing intérieur et nettoyage moteur\n• Entretien léger → Basique garde les choses fraîches entre les nettoyages profonds'
        ],
        showBooking: false
      },

      // === DURÉE ===
      {
        tag: 'duration',
        patterns: [
          'combien de temps', 'durée', 'combien d\'heures',
          'combien de temps ça prend', 'temps nécessaire', 'temps requis',
          'combien de minutes', 'temps d\'attente', 'délai',
          'c\'est rapide', 'c\'est vite', 'est-ce rapide',
          'ça prend longtemps', 'prend combien de temps',
          'temps de traitement', 'temps de complétion',
          'quand ce sera fini', 'quand ce sera prêt',
          'même jour', 'service même jour',
          'pressé', 'urgent', 'service express'
        ],
        responses: [
          'La durée du service dépend du forfait et de la taille du véhicule. Basique est le plus rapide, tandis que Deluxe prend plus de temps pour le nettoyage en profondeur. Vous pouvez sélectionner votre créneau horaire préféré lors de la réservation en ligne.'
        ],
        showBooking: true
      },

      // === CONTACT ===
      {
        tag: 'contact',
        patterns: [
          'contact', 'téléphone', 'appeler', 'courriel', 'whatsapp', 'joindre',
          'numéro de téléphone', 'parler à quelqu\'un', 'humain',
          'service client', 'support', 'nous contacter',
          'coordonnées', 'informations de contact', 'détails de contact',
          'votre numéro', 'votre téléphone', 'votre courriel', 'votre whatsapp',
          'comment contacter', 'comment joindre', 'comment appeler',
          'donnez-moi votre numéro', 'donnez-moi votre courriel',
          'puis-je appeler', 'puis-je écrire', 'puis-je texter',
          'envoyer courriel', 'envoyer message', 'écrire',
          'parler à une personne', 'vraie personne', 'personne réelle',
          'agent en direct', 'clavardage en direct', 'agent humain',
          'opérateur', 'représentant', 'agent',
          'je veux parler', 'je veux appeler',
          'connectez-moi', 'transférez-moi'
        ],
        responses: [
          `Vous pouvez nous joindre à tout moment :\n📞 ${PHONE}\n📲 WhatsApp disponible\n📧 ${EMAIL}\n\nOu réservez directement en ligne pour le service le plus rapide.`
        ],
        showBooking: false
      },

      // === DEMANDES SPÉCIALES (ESCALADE) ===
      {
        tag: 'special',
        patterns: [
          'flotte', 'concessionnaire', 'corporatif', 'partenariat', 'en gros',
          'taches tenaces', 'accident', 'soumission', 'plainte',
          'remboursement', 'insatisfait', 'mécontent',
          'frustré', 'fâché', 'terrible', 'mauvais service', 'gérant',
          'prix flotte', 'rabais flotte', 'service flotte',
          'compte corporatif', 'prix corporatif', 'offre corporatif',
          'compte entreprise', 'prix entreprise',
          'partenariat concessionnaire', 'concessionnaire auto',
          'prix en gros', 'rabais volume', 'plusieurs voitures',
          'beaucoup de voitures', 'toute la flotte',
          'service personnalisé', 'forfait personnalisé', 'travail personnalisé',
          'demande spéciale', 'service spécial', 'besoin spécial',
          'nettoyage intensif', 'nettoyage extrême',
          'dommage accident', 'dommage collision', 'dommage carrosserie',
          'dommage peinture', 'rayures profondes', 'rayures majeures',
          'déposer plainte', 'faire une plainte', 'je veux me plaindre',
          'je veux un remboursement', 'argent remis', 'rembourser',
          'pas content', 'déçu', 'insatisfait', 'mauvais service',
          'mauvaise expérience', 'pire', 'horrible', 'affreux',
          'parler au gérant', 'superviseur', 'escalader', 'inacceptable'
        ],
        responses: [
          `Pour les demandes spéciales ou soumissions personnalisées, veuillez nous contacter directement et notre équipe vous répondra rapidement.\n📞 ${PHONE}\n📲 WhatsApp disponible\n📧 ${EMAIL}`
        ],
        showBooking: false,
        escalation: true
      },

      // === POLISSAGE / CIRAGE / RAYURES ===
      {
        tag: 'polishing',
        patterns: [
          'polissage', 'polir', 'cirage', 'cire', 'rayure', 'rayures',
          'élimination rayures', 'enlever rayures', 'réparer rayures',
          'marques tourbillon', 'tourbillons', 'éraflures',
          'ponçage', 'poncer', 'correction peinture', 'réparation peinture',
          'rayures mineures', 'petites rayures', 'rayures légères',
          'rayures surface', 'dommage surface',
          'peinture terne', 'peinture décolorée', 'peinture oxydée',
          'restaurer brillance', 'redonner brillance', 'faire briller',
          'lustré', 'lustre', 'fini miroir', 'fini salon',
          'décontamination', 'dépôts fer', 'poussière frein',
          'goudron', 'résidu insectes', 'polissage extérieur'
        ],
        responses: [
          'Nous offrons des services professionnels de polissage, cirage et élimination des rayures :\n• Polissage Extérieur & Élimination Rayures - Lisse les surfaces, élimine les rayures mineures et tourbillons\n• Décontamination Extérieure & Cirage - Élimine les dépôts de fer, poussière de frein, goudron, suivi d\'une protection à la cire\n\nCes services restaurent la brillance de votre véhicule et protègent la peinture.'
        ],
        showBooking: true
      },

      // === ROUES / PNEUS ===
      {
        tag: 'wheels',
        patterns: [
          'roue', 'roues', 'pneu', 'pneus', 'jante', 'jantes',
          'nettoyage roues', 'nettoyage pneus', 'nettoyage jantes',
          'lavage roues', 'lavage pneus', 'lavage jantes',
          'poussière frein', 'crasse roues', 'roues sales', 'jantes sales',
          'pneus sales', 'nettoyage profond roues', 'nettoyage profond pneus',
          'jantes alliage', 'nettoyage alliage', 'brillance pneus',
          'habillage pneus', 'dommage roue', 'restauration roue'
        ],
        responses: [
          'Nous offrons un Nettoyage Profond des Roues & Pneus qui élimine toute la poussière de frein et la crasse, gardant vos jantes et pneus polis et brillants. Ce service est inclus dans notre forfait Super Mensuel, ou disponible en service individuel.'
        ],
        showBooking: true
      },

      // === RESTAURATION PHARES ===
      {
        tag: 'headlight',
        patterns: [
          'phare', 'phares', 'restauration phares',
          'phares embrouillés', 'phares nuageux', 'phares jaunes',
          'phares ternes', 'phares opaques', 'phares oxydés',
          'nettoyage phares', 'réparation phares', 'réparer phares',
          'restaurer phares', 'nettoyer phares',
          'lumières avant', 'restauration lumières'
        ],
        responses: [
          'Nous offrons une restauration professionnelle des phares — nettoyage en profondeur et restauration des phares embrouillés, nuageux ou jaunis pour améliorer la visibilité et l\'apparence. Ce service peut aussi être ajouté comme amélioration à notre forfait Super.'
        ],
        showBooking: true
      },

      // === SELLERIE / CUIR / SIÈGES ===
      {
        tag: 'upholstery',
        patterns: [
          'sellerie', 'cuir', 'sièges', 'nettoyage sièges', 'shampoing sièges',
          'traitement cuir', 'conditionnement cuir', 'soin cuir',
          'nettoyage cuir', 'sièges cuir', 'sièges tissu',
          'sièges en tissu', 'taches sièges', 'sièges tachés',
          'sièges sales', 'nettoyer sièges', 'laver sièges',
          'shampoing', 'shampoing tapis', 'nettoyage tapis',
          'nettoyage plancher', 'tapis de sol',
          'shampoing intérieur', 'intérieur profond', 'taches intérieur',
          'déversement', 'taches nourriture', 'taches boisson',
          'tache café', 'tache jus', 'poils animaux', 'poils chien',
          'poils chat', 'odeur', 'odeurs', 'mauvaise odeur',
          'enlever odeur', 'désodoriser', 'rafraîchir'
        ],
        responses: [
          'Nous offrons le Shampoing de Sellerie et Traitement Cuir :\n• Shampoing des sièges en tissu et en cuir\n• Nettoyage, traitement et conditionnement des surfaces en cuir\n• Nettoyage en profondeur des tapis et tapis de sol\n\nNote : Le lavage ou l\'esthétique intérieure doit être ajouté avec ce service.'
        ],
        showBooking: true
      },

      // === REMERCIEMENTS ===
      {
        tag: 'thanks',
        patterns: [
          'merci', 'remercie', 'très apprécié', 'très utile',
          'merci beaucoup', 'merci infiniment',
          'mille merci', 'grand merci', 'tellement merci',
          'ça aide', 'ça a aidé', 'tellement utile',
          'bravo', 'beau travail', 'bien fait',
          'c\'était utile', 'j\'apprécie', 'reconnaissant'
        ],
        responses: [
          'De rien! Y a-t-il autre chose que je puisse faire pour vous? Si vous êtes prêt, vous pouvez réserver votre rendez-vous à tout moment.'
        ],
        showBooking: false
      },

      // === AU REVOIR ===
      {
        tag: 'goodbye',
        patterns: [
          'au revoir', 'bye', 'à bientôt', 'à plus', 'bonne journée',
          'c\'est tout', 'rien d\'autre', 'non merci',
          'salut', 'à la prochaine', 'on se revoit',
          'je dois y aller', 'je pars', 'j\'ai fini',
          'c\'est terminé', 'plus de questions', 'plus rien',
          'je suis bon', 'tout est bon', 'c\'est correct',
          'bonne soirée', 'bonne nuit', 'à plus tard',
          'non merci', 'non c\'est bon', 'non ça va'
        ],
        responses: [
          'Merci d\'avoir discuté avec InstaCarSpa! Nous avons hâte de faire briller votre voiture. Bonne journée!'
        ],
        showBooking: false
      },

      // === HÉSITATION ===
      {
        tag: 'hesitation',
        patterns: [
          'peut-être plus tard', 'je vais y penser', 'pas sûr', 'laissez-moi réfléchir',
          'je ne sais pas', 'hmm', 'pas maintenant', 'plus tard',
          'peut-être', 'possiblement', 'on verra', 'je verrai',
          'je vais réfléchir', 'laissez-moi considérer', 'besoin de réfléchir',
          'pas prêt', 'pas encore', 'pas tout de suite', 'une autre fois',
          'un autre jour', 'la prochaine fois', 'la semaine prochaine',
          'j\'y pense', 'je considère', 'j\'hésite',
          'encore en train de décider', 'donnez-moi du temps',
          'besoin de plus de temps', 'revenir plus tard',
          'je reviendrai', 'je vous reviens', 'je vous tiens au courant'
        ],
        responses: [
          'Aucune pression! La réservation prend moins de 60 secondes et vous pouvez toujours modifier votre rendez-vous au besoin. Quand vous serez prêt, nous sommes là.'
        ],
        showBooking: false
      },

      // === SERVICE MOBILE ===
      {
        tag: 'mobile',
        patterns: [
          'mobile', 'venir chez moi', 'à domicile', 'service à domicile', 'stationnement',
          'mon immeuble', 'dans l\'immeuble', 'chez moi', 'service sur place',
          'service mobile', 'venir à mon domicile', 'venir chez nous',
          'venir à mon immeuble', 'venir à mon stationnement',
          'dans mon immeuble', 'dans mon stationnement', 'à ma porte',
          'pas de porte', 'livraison à domicile',
          'venez-vous', 'pouvez-vous venir', 'est-ce que vous venez',
          'venez chez nous', 'visitez-nous', 'visitez-moi',
          'sur place', 'esthétique mobile', 'lavage mobile',
          'nettoyage mobile', 'portable', 'pratique', 'commodité',
          'pas envie de conduire', 'ramassage', 'déposer',
          'condo', 'appartement', 'stationnement immeuble',
          'stationnement souterrain', 'garage', 'mon garage',
          'entrée', 'mon entrée', 'frais transport', 'frais déplacement',
          'frais mobile', 'frais livraison'
        ],
        responses: [
          'Oui! Nous offrons un service de lavage et d\'esthétique automobile directement à votre place de stationnement. C\'est la façon la plus pratique de garder votre voiture propre. Sélectionnez votre emplacement lors de la réservation et nous viendrons à vous.\n\nNote : Pour le service mobile, des frais de transport seront ajoutés aux prix.'
        ],
        showBooking: true
      },

      // === HEURES / HORAIRE ===
      {
        tag: 'hours',
        patterns: [
          'heures', 'ouvert', 'fermé', 'heures d\'ouverture', 'heures de fermeture',
          'heures d\'affaires', 'heures de travail', 'heures d\'opération',
          'quelle heure', 'quand ouvrez', 'quand fermez',
          'êtes-vous ouvert', 'êtes-vous fermé',
          'ouvert aujourd\'hui', 'ouvert demain', 'ouvert fin de semaine',
          'ouvert dimanche', 'ouvert samedi', 'ouvert lundi',
          'heures fin de semaine', 'heures semaine', 'heures fériés',
          'horaire', 'quels jours', 'jours d\'opération',
          'ouvert les fériés', 'fermé les fériés',
          'tôt le matin', 'tard le soir', 'service de nuit'
        ],
        responses: [
          'Vous pouvez vérifier nos créneaux horaires et heures disponibles en cliquant sur Réserver maintenant — le système de réservation affiche toutes les dates et heures disponibles pour votre emplacement préféré.'
        ],
        showBooking: true
      },

      // === TAILLE / TYPE VÉHICULE ===
      {
        tag: 'vehicle_size',
        patterns: [
          'taille voiture', 'taille véhicule', 'vus', 'berline', 'compact',
          'fourgonnette', 'camionnette', 'camion', 'van', 'hayon',
          'coupé', 'décapotable', 'voiture sport', 'voiture luxe',
          'grosse voiture', 'petite voiture', 'gros véhicule', 'petit véhicule',
          '2 places', '5 places', '7 places', 'deux places', 'cinq places', 'sept places',
          'quelle taille', 'type de voiture', 'taille importe',
          'prix par taille', 'coût par taille',
          'prix vus', 'prix berline', 'prix compact',
          'prix fourgonnette', 'prix camionnette',
          'lavez-vous les vus', 'lavez-vous les camions',
          'gros vus', 'pleine grandeur', 'taille moyenne',
          'multisegment', 'jeep', 'tesla', 'voiture électrique'
        ],
        responses: [
          'Nous servons tous les types de véhicules! Nos prix sont basés sur trois catégories :\n• Voitures Compactes 2 Places\n• Berlines & VUS 5 Places\n• VUS, Camionnettes & Fourgonnettes 7 Places\n\nVous pouvez sélectionner la taille de votre véhicule lors de la réservation.'
        ],
        showBooking: true
      },

      // === ÉCO-RESPONSABLE ===
      {
        tag: 'eco',
        patterns: [
          'éco', 'éco-responsable', 'écologique', 'vert', 'environnement',
          'environnemental', 'biodégradable', 'durable', 'biologique',
          'sans produits chimiques', 'non toxique', 'produits sécuritaires',
          'quels produits', 'produits utilisés', 'produits de nettoyage',
          'utilisation eau', 'gaspillage eau', 'économie eau', 'sans eau'
        ],
        responses: [
          'InstaCarSpa est un service éco-responsable! Nous utilisons des produits biodégradables et écologiques modernes pour tous nos nettoyages. Notre objectif est d\'offrir la meilleure expérience de lavage auto tout en étant responsable envers l\'environnement.'
        ],
        showBooking: true
      },

      // === À PROPOS / IDENTITÉ ===
      {
        tag: 'about',
        patterns: [
          'c\'est quoi instacarspa', 'c\'est quoi insta car spa',
          'qui est instacarspa', 'qui êtes-vous', 'à propos instacarspa',
          'à propos de instacarspa', 'parlez-moi de instacarspa',
          'parlez-moi de insta car spa',
          'à propos de vous', 'à propos de votre entreprise',
          'c\'est quoi ici', 'c\'est quoi cette entreprise',
          'qui êtes-vous', 'décrivez instacarspa',
          'décrivez votre entreprise', 'quel type d\'entreprise',
          'quelle entreprise', 'instacarspa', 'insta car spa',
          'isntacarspa', 'c\'est quoi isntacarspa', 'à propos isntacarspa'
        ],
        responses: [
          'InstaCarSpa est un service professionnel de lavage et d\'esthétique automobile basé à Montréal. Nous offrons un nettoyage éco-responsable intérieur et extérieur, du polissage, du revêtement céramique et plus encore. Nous avons plusieurs emplacements et offrons aussi un service mobile directement à votre place de stationnement. Souhaitez-vous connaître nos forfaits ou réserver un rendez-vous?'
        ],
        showBooking: true
      }
    ],

    fallback: `Merci pour votre message! Je ne suis pas certain d'avoir bien compris. Vous pouvez me poser des questions sur nos services, forfaits, tarifs ou emplacements. Pour des demandes détaillées, contactez-nous :\n📞 ${PHONE}\n📧 ${EMAIL}`,
    fallbackShowBooking: true,

    abandonment: 'Souhaitez-vous que je vous aide à choisir le bon forfait? Je peux vous recommander une option selon l\'état de votre véhicule.',

    bookNowText: '👉 Réserver maintenant',
    bookingLink: BOOKING_LINK
  }
};

export { BOOKING_LINK, PHONE, EMAIL };
